import { Box, Pagination, Paper, useTheme } from "@mui/material";
import useStyles from "./styles";
import CardSelection from "../../2.3-circuito/cardSelection";
import { useState, useEffect } from "react";

export default function ListServicosHostsConfig({
  setSelectedService = () => {},
  selectedService = {},
  filteredServices = [],
  changed = false,
  editMode = false,
  pendingNavigation = {},
  setConfirmacaoSaidaPagina = () => {},
  initialData = {},
}) {
  const theme = useTheme();
  const styles = useStyles(theme);
  const [windowWith, setWindowWith] = useState(window.innerWidth);
  const [page, setPage] = useState(1);
  const itemsPerPage = windowWith > 2000 ? 11 : 8;
  const startIndex = (page - 1) * itemsPerPage;
  const endIndex = startIndex + itemsPerPage;
  const contratosPagina = filteredServices?.slice(startIndex, endIndex);
  const totalPages = Math.ceil((filteredServices?.length || 0) / itemsPerPage);

  const handleChangePagination = (event, newPage) => {
    setPage(newPage);
  };
  useEffect(() => {
    const handleResize = () => {
      setWindowWith(window.innerWidth);
    };

    window.addEventListener("resize", handleResize);
  }, []);

  // Voltar para a primeira página quando o filtro mudar
  useEffect(() => {
    setPage(1);
  }, [filteredServices?.length]);

  return (
    <Paper
      elevation={theme.palette.mode === "dark" ? 0 : 3}
      sx={{ ...styles.paperFluxo, height: "83vh" }}
    >
      {contratosPagina?.map((contrato, index) => {
        const isSelected = selectedService?.id === contrato?.id;
        
        const isConfigured = 
          initialData?.cpes?.[contrato?.id]?.some(h => h?.hostId || h?.hostid) ||
          initialData?.onus?.[contrato?.id]?.some(h => h?.hostId || h?.onuItem) ||
          initialData?.links?.[contrato?.id]?.some(h => h?.hostId || h?.hostid) ||
          initialData?.sessions?.[contrato?.id]?.some(h => h?.hostId || h?.hostid);

        return (
          <CardSelection
            key={contrato?.id}
            idCliente={contrato?.id}
            service={contrato?.nome}
            status={contrato?.status || contrato?.statusContrato}
            selected={isSelected}
            isConfigured={isConfigured}
            ownerNome={contrato?.ownerNome}
            onClick={() => {
              if (isSelected) return;
              if (!!changed && !!editMode) {
                pendingNavigation.current = {
                  type: "accordion",
                  to: contrato,
                };
                setConfirmacaoSaidaPagina(true);
                return;
              }
              setSelectedService(contrato);
            }}
          />
        );
      })}

      {totalPages > 1 && (
        <Box sx={{ display: "flex", justifyContent: "center", mt: 2 }}>
          <Pagination
            count={totalPages}
            page={page}
            onChange={handleChangePagination}
            color="primary"
            size="small"
          />
        </Box>
      )}
    </Paper>
  );
}
